import Navbar from '../../models/Navbar'
import Footer from '../../models/Footer'
import './Home.css';

function Home() {
  return (
    <body>
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

        <Navbar />

        <main style={{ flex: 1 }}>
          <section className="hero">
            <h1>Soluções tecnológicas sob medida</h1>
            <p>Consultoria em tecnologia, desenvolvimento de sistemas personalizados e soluções PDV para lojas físicas e online.</p>
            

            <a href="mailto:contato@soilthm.com">
              <button className="cta-button">Fale conosco</button>
            </a>
          </section>

          <section className="section">
            <h2>Serviços</h2>
            <div className="services">
              <div className="service-card">
                <h3>Consultoria de Tecnologia</h3>
                <p>Diagnóstico e orientação para tomada de decisões eficientes em sua empresa.</p>
              </div>
              <div className="service-card">
                <h3>Sistemas Sob Demanda</h3>
                <p>Software personalizado para atender os objetivos da sua empresa.</p>
              </div>
              <div className="service-card">
                <h3>PDVs e Estoque</h3>
                <p>Soluções completas para varejo seja físico ou online.</p>
              </div>
            </div>
          </section>

          <section class="section">
            <h2>Nossos Pilares</h2>
            <div class="pillars">
              <div class="pillar-item">
                <div class="pillar-text">
                  <h3>Segurança da informação</h3>
                  <p>Utilizamos criptografia de ponta a ponta, autenticação de dois fatores e, quando necessário, tecnologias baseadas em blockchain para garantir a integridade e privacidade das informações em todos os níveis da aplicação.</p>
                </div>
              </div>
              <div class="pillar-item">
                <div class="pillar-text">
                  <h3>Prototipação Ágil</h3>
                  <p>Trabalhamos com ciclos de desenvolvimento curtos, padrões como MVC e estratégias de deploy contínuo para validar soluções com velocidade e entregar melhorias frequentes com menos esforço operacional.</p>
                </div>
              </div>
              <div class="pillar-item">
                <div class="pillar-text">
                  <h3>Análise de Dados</h3>
                <p>Aplicamos conceitos de Business Intelligence (BI) aliados a práticas de análise preditiva para transformar dados em decisões. Com uma abordagem data-driven, ajudamos empresas a enxergar oportunidades, prever comportamentos e otimizar processos estratégicos com base em evidências.</p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </body>
  );
}

export default Home;
